import { useEffect } from 'react';
import { useIsAnyModalOpen } from '@/common/hooks/digioh/use-is-any-modal-open';

/** This hook is used to determine if we have any modals open on our site, and
 *  surfaces that to Digioh as a boolean value. */
export const useDigiohAppStateModal = (isDigiohReady: boolean) => {
  const isAnyModalOpen = useIsAnyModalOpen();

  useEffect(() => {
    if (isDigiohReady && window.DIGIOH_API) {
      window.DIGIOH_API.isModalOpen = isAnyModalOpen;

      if (isAnyModalOpen) {
        window.DIGIOH_API.closeAllBoxes?.();
      }
    }
  }, [isAnyModalOpen, isDigiohReady]);
};
